import { render } from "./RibRequests.vue?vue&type=template&id=30f3e1bd&ts=true"
import script from "./RibRequests.vue?vue&type=script&lang=ts"
export * from "./RibRequests.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__